module.exports = __webpack_public_path__ + "img/ic_airmoney_payment-method.decb01e.svg";